import React from 'react';
import styled from '@emotion/styled';
import { Maybe } from '@types';

type StyledIconProps = {
  url: string;
  color: string;
  hoverColor: string;
  size: number;
  hoverOpacity: number;
  activeColor: Maybe<string>;
  isActive: Maybe<boolean>;
  hoverActiveColor: Maybe<string>;
};

type Props = {
  url: string;
  color?: string;
  hoverColor?: string;
  size?: number;
  hoverOpacity?: number;
  className?: string;
  activeColor?: string;
  hoverActiveColor?: string;
  isActive?: boolean;
  onClick?: () => void;
};

const StyledIcon = styled.span<StyledIconProps>`
  mask: url(${(props) => props.url}) no-repeat center;
  -webkit-mask: url(${(props) => props.url}) no-repeat center;
  mask-size: contain;
  -webkit-mask-size: contain;
  background-color: ${(props) =>
    props.isActive ? props.activeColor ?? props.hoverColor ?? props.color : props.color};
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  transition: 0.3s;
  display: inline-block;
  content: ' ';

  &:hover {
    background-color: ${(props) =>
      props.isActive
        ? props.hoverActiveColor ?? props.hoverColor ?? props.color
        : props.hoverColor ?? props.color};
    opacity: ${(props) => props.hoverOpacity};
  }
`;

const Icon = ({
  color = '#fff',
  hoverColor,
  activeColor,
  hoverActiveColor,
  isActive,
  size = 24,
  url,
  hoverOpacity = 1,
  className = '',
  onClick,
}: Props) => {
  return (
    <StyledIcon
      className={className}
      color={color}
      hoverColor={hoverColor}
      url={url}
      size={size}
      hoverOpacity={hoverOpacity}
      hoverActiveColor={hoverActiveColor}
      isActive={isActive}
      activeColor={activeColor}
      onClick={onClick}
    />
  );
};

export default Icon;
